import clsx from 'clsx';
import React, { useEffect } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import JobListCard from '../../../../components/Card/JobListCard';
import useQueryString from '../../../../hooks/ui-control/useQueryString';
import { useAppSelector } from '../../../../redux/store';

interface BookmarkListsProps {
  showMobileInfo?: boolean;
  setShowMobileInfo: (...args: any) => void;
  loading: boolean;
  reset?: any;
}

const BookmarkLists: React.FC<BookmarkListsProps> = ({
  showMobileInfo,
  setShowMobileInfo,
  loading,
  reset,
}) => {
  const [queryParams, setQueryParams] = useQueryString();
  const { bookmarkJobData } = useAppSelector(
    (state) => state.bookmarkedLocumJobs
  );

  const jobId = queryParams.get('jobId');

  // Auto-select the first job if none is selected
  useEffect(() => {
    if (bookmarkJobData && bookmarkJobData.length > 0) {
      setQueryParams({ jobId: bookmarkJobData[0].job.id });
    } else {
      setQueryParams({ jobId: '' });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset, bookmarkJobData]);

  const handleJobClick = (jobId: string) => {
    setQueryParams({ jobId });
    setShowMobileInfo(!showMobileInfo);
  };

  return (
    <Container className={showMobileInfo ? 'showMobileInfo' : ''}>
      {loading ? (
        <LoadingOutlined />
      ) : bookmarkJobData.length === 0 ? (
        <p>You have no bookmarked jobs</p>
      ) : (
        bookmarkJobData.map((bookmark) => (
          <JobListCard
            key={bookmark.job.id}
            imgSrc={'/static/gif/happyAnimal.gif'} // TODO: place a default image here
            institutionName={bookmark.job?.institutionName}
            jobTitle={bookmark.job.title}
            yearsOfExperience={bookmark.job.yearsOfExperience}
            pay={bookmark.job.pay}
            onClick={(e: any) => handleJobClick(bookmark.job.id)}
            className={clsx(
              'cursor-pointer',
              bookmark.job.id === jobId ? 'active' : ''
            )}
            jobId={bookmark.job.id}
            jobDescription={bookmark.job.jobDescription.jobDescription}
          />
        ))
      )}
    </Container>
  );
};

export default BookmarkLists;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 12px;

  @media (max-width: 884px) {
    display: grid;
    /* border: 1px solid red; */

    &.showMobileInfo {
      display: none;
    }
  }
`;
